import { Http } from '@angular/http';
import { LocalStorageService } from 'angular-2-local-storage';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { AppTranslateService } from './../translations/services/app-translation.service';
import { MissingTranslationHandler } from '@ngx-translate/core';
import { MyMissingTranslationHandler } from './../translations/services/app-missingTranslation.service';
import { CacheKey } from '../shared/constants/cachekey.constants';
export function createTranslateLoader(http) {
    // return new TranslateHttpLoader(http, 'src/app/test/', '.json');
    return new AppTranslateService(http);
}
var ɵ0 = (createTranslateLoader);
var translationOptions = {
    loader: {
        provide: TranslateLoader,
        useFactory: ɵ0,
        deps: [Http, LocalStorageService]
    },
    missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler
    }
};
var AppTranslationModule = /** @class */ (function () {
    function AppTranslationModule(translate, localStorageService) {
        this.translate = translate;
        this.localStorageService = localStorageService;
        this.defaultlang = this.localStorageService.get(CacheKey.DefaultLanguage);
        this.language = this.localStorageService.get(CacheKey.Language);
        if (this.language != null && this.language != undefined) {
            this.translate.use(this.language);
        }
        else if (this.defaultlang != null && this.defaultlang != undefined) {
            this.translate.use(this.defaultlang);
        }
    }
    return AppTranslationModule;
}());
export { AppTranslationModule };
export { ɵ0 };



// WEBPACK FOOTER //
// ./src/app/translations/app-translations.module.ts.pre-build-optimizer.js